var livePageForm = {};
livePageForm.formObj = document.getElementById("guide-live-page-form");
livePageForm.urlField = document.getElementById("guide-form-url");
livePageForm.submitBtn = document.getElementById("guide-form-submit-btn");

var urlLiveForm = (function(livePageForm) {
  return {
    validateFields: _validateFields
  };

  function _validateFields() {
    var formValid = true,
      url = livePageForm.urlField.value,
      urlError = document.getElementById("url-error"),
      urlValidation = validURL(livePageForm.urlField.value);
      
    if (livePageForm.urlField.value == "" || urlValidation.isInvalid) {
      formValid = _showError(
        livePageForm.urlField,
        urlError,
        "url-error",
        urlValidation.errorMessage
      );
    } else {
      livePageForm.urlField.classList.remove("error-border");
      livePageForm.urlField.removeAttribute('aria-describedby');
      if (urlError) {
        urlError.remove();
      }
    }

    if (formValid) {
      livePageForm.submitBtn.setAttribute("disabled", "disabled");
      livePageForm.submitBtn.value = livePageForm.submitBtn.dataset.btndisabled;

      bsLib.ajax(
        "POST",
        window.location.protocol +
          "//" +
          window.location.hostname +
          "/wp-admin/admin-ajax.php",
        {
          action: "bstack_check_valid_url",
          security: ajax_initialize_script.ajax_nonce, // nonce
          url: url
        },
        true, //async
        {
          "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
        }, //request header
        function(data) {
          var dataRequest = bsLib.JSONParse(data.response);
          if(dataRequest) {
            livePageForm.submitBtn.removeAttribute("disabled");
            livePageForm.submitBtn.value = livePageForm.submitBtn.dataset.btntext;

            if (dataRequest.status) {
              livePageForm.formObj.dataset.validated = 1;
              livePageForm.formObj.submit();
            } else {
              var errorCount = livePageForm.urlField.parentNode.getElementsByClassName("error-message").length;
              if (errorCount === 0) {
                _showError(
                  livePageForm.urlField,
                  urlError,
                  "url-error",
                  urlValidation.errorMessage
                );
              }
            }
          }
        }, //success
        function() {} //error object
      );
    }

    return formValid;
  }

  function validURL(str) {
    var pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
      "i"
    ); // fragment locator
    return {
      isInvalid: !pattern.test(str),
      errorMessage: "Please enter a valid URL"
    };
  }

  function _showError(fieldName, fieldError, errorName, errorMessage) {
    inlineError.showError(fieldName, fieldError, errorName, errorMessage);
    fieldName.setAttribute('aria-describedby', errorName);

    WebEventTracker.logEvent(EDS.webEvents, "InteractedWithFloatingLiveURL", {
      action: errorName,
      message: errorMessage,
      InvalidInput: true
    });
  }
})(livePageForm);

if (livePageForm.urlField) {
  //focus url input field
  //livePageForm.urlField.focus();
  //livePageForm.urlField.select();

  livePageForm.urlField.addEventListener("blur", function(e) {
    WebEventTracker.logEvent(EDS.webEvents, "InteractedWithFloatingLiveURL", {
      action: "Entered URL"
    });
  });
}

if (livePageForm.formObj) {
  livePageForm.formObj.addEventListener("submit", function(e) {
    e.preventDefault();
    
    if (livePageForm.formObj.dataset.validated === "1") {
      return true;
    }
    WebEventTracker.logEvent(EDS.webEvents, "InteractedWithFloatingLiveURL", {
      action: "Clicked Test Now"
    });

    return urlLiveForm.validateFields();
  });
}
